import * as React from "react";
import { cn } from "@/lib/utils.js";

/**
 * Checkbox component
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {React.Ref<HTMLInputElement>} ref - Forwarded ref
 * @param {...Object} props - Other input HTML attributes
 * @returns {JSX.Element} Checkbox input
 */
const Checkbox = React.forwardRef(
  /** @param {{ className?: string, [key: string]: any }} props */
  ({ className, ...props }, ref) => {
    return (
      <input
        type='checkbox'
        className={cn(
          "h-4 w-4 shrink-0 rounded border border-border bg-background",
          "text-primary accent-primary",
          "focus:ring-primary focus:ring-2 focus:ring-offset-2 focus:ring-offset-background",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Checkbox.displayName = "Checkbox";

export { Checkbox };
